<template>
  <div class="property-index-container">
    <div class="page-heading">
      <div>
        <div class="page-eyebrow"><i class="el-icon-s-home"></i>{{ $t('propertyIndex.home') }}</div>
        <h1>{{ $t('propertyIndex.dashboard') }}</h1>
        <p>统一查看社区资产、住户反馈与业务处理情况</p>
      </div>
    </div>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="15">
        <index-community ref="indexCommunity" />
      </el-col>
      <el-col :span="9">
        <index-notice ref="indexNotice" />
      </el-col>
    </el-row>

    <el-row class="vc-index-1" :gutter="20">
      <el-col :span="15">
        <index-repair-complaint ref="indexRepairComplaint" />
      </el-col>
      <el-col :span="9">
        <index-owner-room ref="indexOwnerRoom" />
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IndexCommunity from '@/components/index/indexCommunity'
import IndexNotice from '@/components/index/indexNotice'
import IndexRepairComplaint from '@/components/index/indexRepairComplaint'
import IndexOwnerRoom from '@/components/index/indexOwnerRoom'

export default {
  name: 'PropertyIndexList',
  components: {
    IndexCommunity,
    IndexNotice,
    IndexRepairComplaint,
    IndexOwnerRoom
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData() {
      this.$refs.indexCommunity._loadPropertyIndexAssets()
      this.$refs.indexNotice._loadPropertyIndexNotices()
      this.$refs.indexRepairComplaint.initData()
      this.$refs.indexOwnerRoom._loadIndexOwnerRegisterData()
    }
  }
}
</script>

<style lang="scss" scoped>
.property-index-container {
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
  padding: 24px;
  background: var(--hc-page-bg);
  text-align: left;

  .page-heading {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;

    .page-eyebrow {
      color: var(--hc-primary);
      font-size: 12px;
      font-weight: 600;
      letter-spacing: 1px;

      i {
        margin-right: 6px;
      }
    }

    h1 {
      margin: 5px 0 6px;
      color: var(--hc-text-primary);
      font-size: 24px;
      line-height: 1.2;
      font-weight: 650;
    }

    p {
      margin: 0;
      color: var(--hc-text-secondary);
      font-size: 14px;
    }
  }

  .margin-right-sm {
    margin-right: 5px;
  }

  .margin-left-sm {
    margin-left: 5px;
  }

  .margin-top-lg {
    margin-top: 15px;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .vc-index-1 {
    margin-bottom: 20px;

    .index-1-left,
    .index-1-right {
      height: 100%;
    }
  }
}

@media (max-width: 1100px) {
  .property-index-container {
    padding: 18px;
  }
}
</style>
